const ProjectsList = () =>
  import(/* webpackChunkName: "projects-list" */ '@/components/projects/projects-list');
const ProjectNew = () =>
  import(/* webpackChunkName: "project-form" */ '@/components/projects/project-new');
const ProjectEdit = () =>
  import(/* webpackChunkName: "project-form" */ '@/components/projects/project-edit');
const LicenceAreas = () =>
  import(
    /* webpackChunkName: "projects" */ '@/components/projects/licence-areas/licence-areas-list'
  );
const LicenceAreasNew = () =>
  import(/* webpackChunkName: "projects" */ '@/components/projects/licence-areas/licence-area-new');
const LicenceAreaEdit = () =>
  import(
    /* webpackChunkName: "projects" */ '@/components/projects/licence-areas/licence-area-edit'
  );
const ZonesList = () =>
  import(/* webpackChunkName: "projects" */ '@/components/projects/zones/zones-list');
const NewZone = () =>
  import(/* webpackChunkName: "projects" */ '@/components/projects/zones/zone-new');
const EditZone = () =>
  import(/* webpackChunkName: "projects" */ '@/components/projects/zones/zone-edit');

const PROJECTS_ROUTES = [
  {
    path: '/projects',
    alias: '/',
    name: 'projects',
    component: ProjectsList
  },
  {
    path: '/projects/new',
    name: 'newProject',
    component: ProjectNew
  },
  {
    path: '/project/:projectCode/edit',
    name: 'editProject',
    component: ProjectEdit,
    props: true
  },
  {
    path: '/project/:projectCode/licence-areas',
    name: 'licenceAreas',
    component: LicenceAreas,
    props: true
  },
  {
    path: '/project/:projectCode/licence-areas/new',
    name: 'newLicenceAreas',
    component: LicenceAreasNew,
    props: true
  },
  {
    path: '/project/:projectCode/licence-area/:licenceAreaCode/edit',
    name: 'editLicenceArea',
    component: LicenceAreaEdit,
    props: true
  },
  {
    path: '/project/:projectCode/zones',
    name: 'zonesList',
    component: ZonesList,
    props: true
  },
  {
    path: '/project/:projectCode/zones/new',
    name: 'newZone',
    component: NewZone,
    props: true
  },
  {
    path: '/project/:projectCode/zones/:zoneCode/edit',
    name: 'editZone',
    component: EditZone,
    props: true
  }
];

export default PROJECTS_ROUTES;
